export const ACTIVE_REGION_KEY = 'active_region';
export const AUTH_KEY = 'auth';
export const REGIONS_KEY = 'regions';
export const USER_ACTIVE_KEY = 'user_active';
export const PERMISSIONS_KEY = 'permissions';
export const REFRESHING_TOKEN_KEY = 'refreshing_token';
export const LANG_KEY = 'lang';
